<template>
	<div>
		<!-- begin breadcrumb -->
		<ol class="breadcrumb float-xl-right">
			<li class="breadcrumb-item active"><a href="javascript:;">Pago a Personal</a></li>
		</ol>
		<!-- end breadcrumb -->
		<!-- begin page-header -->
		<h1 class="page-header">Pago a Personal </h1>
		<!-- end page-header -->
		<!-- begin panel -->
		<!-- <panel title="Panel Title here">
			Panel Content Here
		</panel> -->
		<!-- end panel -->
		<!-- begin card -->
		<div class="card  border-0 ">
			<div class="card-body table-responsive">

				<div class="row ">
					<div class="col-lg-2">
						<select class="form-control" v-model="mes" name="" id="">
							<option value="">Seleccione Mes</option>
							<option value="1">Enero</option>
							<option value="2">Febrero</option>
							<option value="3">Marzo</option>
							<option value="4">Abril</option>
							<option value="5">Mayo</option>
							<option value="6">Junio</option>
							<option value="7">Julio</option>
							<option value="8">Agosto</option>
							<option value="9">Setiembre</option>
							<option value="10">Octubre</option>
							<option value="11">Noviembre</option>
							<option value="12">Diciembre</option>
						</select>
					</div>
					<div class="col-lg-2">
						<input type="text" v-model="anio" class="form-control font-weight-bold" maxlength="4"
							placeholder="Ingrese año">
					</div>

					<div class="col-lg-2">
						<button v-if="$store.state.usuario.tipo==2" type="button" @click="buscar()" class="btn btn-info"> <i class="fa fa-search"></i>
							Buscar</button>
						<button v-if="$store.state.usuario.tipo>2" type="button" @click="buscarPorResponsable()" class="btn btn-primary"> <i class="fa fa-search"></i>
							Buscar</button>
					</div>
					<div class="col-lg-2">
						<export-excel v-show="reportes.length>0" :footer="'TOTAL REGISTRADOS: '+reportes.length"
							:title="'::..REPORTE DE PAGO A PERSONAL - SISTEMA TELEMARTIN '+mes+'/'+anio+'..::'"
							class="btn btn-success btn-sm btn-block" :data="reportes" :fields="json_fields"
							worksheet="pago" name="pago_personal.xls">
							<i class="fa fa-download"></i> Excel
						</export-excel>
					</div>

				</div>

			</div>
		</div>
		<!-- begin row -->
		<div class="row animated fadeIn" v-if="nuevoComisionChip==0">
			<!-- begin col-12 -->
			<div class="col-xl-12 card card-body table-responsive">
				<table class="table table-sm table-hover">
					<tr class="h3 bg-yellow">
						<th>Tipo Vendedor</th>
						<th>DNI</th>
						<th>Vendedor</th>
						<th>Monto Chip</th>
						<th>Monto Equipo</th>
						<th>Monto Adelanto</th>
						<th>Total</th>
						<th>Est. Cuenta</th>
						<th>Boleta </th>
					</tr>
					<tr v-for="r in reportes" :key="r.dni">
						<td class="h4">{{r.tipo}}</td>
						<td class="h4" v-show="$store.state.usuario.tipo==2" >{{r.dni}}</td>
						<td class="h4" v-show="$store.state.usuario.tipo==5 || $store.state.usuario.tipo==6 || $store.state.usuario.tipo==7" :class="{'bg-danger':(parseFloat(r.total)+parseFloat(r.monto_adelanto))<20}" >{{r.dni}}</td>
						<td class="h4" v-show="$store.state.usuario.tipo==4" :class="{'bg-danger':(parseFloat(r.total)+parseFloat(r.monto_adelanto))<10}">{{r.dni}}</td>
						<td class="h4" v-show="$store.state.usuario.tipo==3" :class="{'bg-danger':(parseFloat(r.total)+parseFloat(r.monto_adelanto))<200}">{{r.dni}}</td>
						<td class="h4">{{r.trabajador}}</td>
						<td class="h4">{{r.monto_chip}}</td>
						<td class="h4">{{r.monto_equipo}}</td>
						<td class="h4">{{r.monto_adelanto}}</td>
						<td class="h4">{{r.total}}</td>
						<td> <a :href="'#/reporte/pago-personal/estado-cuenta/'+mes+'/'+anio+'/'+r.dni+'/'+r.trabajador"
								class="btn btn-dark btn-sm btn-block"> <i class="fa fa-check"></i> Ver estado</a></td>
						<td> <a v-b-modal.modalBoleta href="javascript:;"
								@click="boleta.dni=r.dni;boleta.tipo_vendedor=r.tipo;boleta.personal=r.trabajador;cargarSaldoAnterior()"
								class="btn btn-dark btn-sm btn-block"> <i class="fa fa-file"></i> </a></td>

					</tr>
					<tfoot  class="bg-orange rounded">
						<tr v-show="$store.state.usuario.tipo==2">
							<th colspan="3" class="h2 text-center">TOTALES</th>
							<th class="h2">+{{(Number(total_chip)).toFixed(2)}}</th>
							<th class="h2">+{{total_equipo}}</th>
							<th class="h2">-{{total_adelanto}}</th>
							<th class="h2">S/.{{(Number(total)).toFixed(2)}}</th>
							<th class="h4 text-center">---</th>
							<th class="h4 text-center">---</th>
						</tr>
						<tr class="bg-info rounded">
							<th colspan="5" class="h2 text-center">TOTALES PARA COMISION</th>
							<th class="h2">S/.</th>
							<th class="h2">{{(Number(sumaComisionVendedoresActivos)).toFixed(2)}}</th>
							<th class="h4 text-center">---</th>
							<th class="h4 text-center">---</th>
						</tr>
						<tr v-show="false"  class="bg-info rounded"  v-if="$store.state.usuario.tipo>2">
							<th colspan="5" class="h2 text-center">COMISIÓN POR N° DE VENDEDORES</th>
							<th class="h2">S/.</th>
							<th class="h2">{{(Number(comisionPorNroVendedoresv2)).toFixed(2)}}</th>
							<th class="h4 text-center">---</th>
							<th class="h4 text-center">---</th>
						</tr>
						<tr   v-show="false" class="bg-info rounded" v-if="$store.state.usuario.tipo>2">
							<th colspan="6" class="h2 text-center">VENDEDORES ACTIVOS</th>
							<th class="h2">{{(Number(vendedoresActivos))}}</th>
							<th class="h4 text-center">---</th>
							<th class="h4 text-center">---</th>
						</tr>
						<tr  v-show="false" class="bg-info rounded" v-if="$store.state.usuario.tipo>2">
							<th colspan="5" class="h2 text-center">SUMA DE COMISIÓN DE LOS VENDEDORES</th>
							<th class="h2">S/.</th>
							<th class="h2">{{(Number(sumaComisionVendedoresActivos)).toFixed(2)}}</th>
							<th class="h4 text-center">---</th>
							<th class="h4 text-center">---</th>
						</tr>
						<tr   v-show="false" class="bg-info rounded" v-if="$store.state.usuario.tipo>2">
							<th colspan="5" class="h2 text-center">COMISIÓN DE 10%</th>
							<th class="h2">S/.</th>
							<th class="h2">{{(Number(comisionDiezPorciento)).toFixed(2)}}</th>
							<th class="h4 text-center">---</th>
							<th class="h4 text-center">---</th>
						</tr>
						<tr  v-show="false"  class="bg-info rounded" v-if="$store.state.usuario.tipo>2">
							<th colspan="5" class="h2 text-center">TOTAL A COBRAR</th>
							<th class="h2">S/.</th>
							<th class="h2">{{(Number(totalCobrar)).toFixed(2)}}</th>
							<th class="h4 text-center">---</th>
							<th class="h4 text-center">---</th>
						</tr>
					</tfoot>
				</table>
				<procesando v-if="proceso" />
			</div>
			<!-- end col-12 -->
		</div>
		<!-- end row -->
		<!-- begin row -->

		<!-- end row -->


		<b-modal ref="modalBoleta" size="xl" id="modalBoleta" cancel-variant="default" title="Saldos anteriores">
			<div class="row bg-yellow ">
				<div class="col-lg-4 col-md-3 col-sm-12 col-xs-12">
					<label for="">DNI: <b>{{boleta.dni}}</b></label>
				</div>
				<div class="col-lg-4 col-md-7 col-sm-12 col-xs-12">
					<label for="">Personal: <b>{{boleta.personal}}</b></label>
				</div>
				<div class="col-lg-4 col-md-2 col-sm-12 col-xs-12">
					<label v-show="$store.state.usuario.tipo==2" for="">Tipo Vend.: <b>{{boleta.tipo_vendedor}}</b></label>
					<label v-show="$store.state.usuario.tipo!=2"  for="">Tipo Usuario Activo: <b>{{filtrar($store.state.usuario.tipo_vendedor)}}</b></label>
				</div>
				
			</div>
			<div class="table-responsive">
				<table class="table table-hover">
					<thead>
						<tr>
							<th>AÑO</th>
							<th>MES</th>
							<th>MONTO CHIP</th>
							<th>MONTO EQUIPO</th>
							<th>MONTO ADELANTOS</th>
							<th>MONTO TOTAL</th>
							
							
							
							<th>BOLETA</th>
						</tr>
					</thead>
					<tr v-for="m  in montos_anteriores" :key="m.Id">
						<td>{{m.anio}}</td>
						<td>{{m.mes}}</td>
						<td>S/.{{m.monto_chip}}</td>

						<td>S/.{{m.monto_equipo}}</td>
						<td>- S/.{{m.monto_adelanto}}</td>
						<th>S/.{{m.total}}</th>
				
						<th>

							<b-button variant="secondary" size="sm" class="float-right"
								@click="imprimirBoleta(m.monto_chip,m.monto_equipo,m.monto_adelanto,m.total,m.mes,boleta.personal)">
								Boleta
							</b-button>

						</th>
					</tr>
				</table>
			</div>
			<hr>
			<div v-if="false">
				<h4 v-show="boleta.tipo_vendedor=='PDV' && anio>2021 && $store.state.usuario.tipo==2">BONOS</h4>
			<div class="table-responsive">
				<table v-show="boleta.tipo_vendedor=='PDV' && anio>2021 && $store.state.usuario.tipo==2" class="table table-hover">
					<thead>
						<tr>
							<th>AGUINALDO ESCOLAR (14 de Marzo)</th>
							<th>AGUINALDO FIESTAS PATRIAS (18 de Julio)</th>
							<th>AGUINALDO POR NAVIDAD (Diciembre)</th>
						</tr>
					</thead>
					<tr>
						<th>S/.{{escolaridad_total}}</th>
						<th>S/.{{fiestas_patrias_total}}</th>
						<th>S/.{{navidad_total}}</th>
					</tr>
				</table>
			</div>
			</div>
			
			<template #modal-footer>
				<b-button variant="secondary" size="sm" class="float-right" @click="$bvModal.hide('modalBoleta')">Cerrar
				</b-button>
			</template>
		</b-modal>

	</div>
</template>
<script>
	import Vue from "vue";
	import excel from "vue-excel-export";
	import procesando from '../components/compartidos/Procesando'
	Vue.use(excel);
	import axios from 'axios'
	export default {
		name: "PagoPersonal",
		components: {
			procesando
		},
		created() {
			// this.loadItems() ;
		},
		data() {
			return {
				json_fields: {
					"Tipo Vendedor": "tipo",
					Vendedor: "trabajador",
					Departamento: "departamento",
					Celular: "cel",
					DNI: {
						field: "dni",
						callback: value => {
							return `DNI - ${value}`;
						}
					},
					"Monto Chip": "monto_chip",
					"Monto Equipo": "monto_equipo",
					"Monto Adelanto": "monto_adelanto",
					"Total": "total",
				},
				anio: "",
				mes: "",
				proceso: false,
				nuevo: true,
				comisionChip: null,
				nuevoComisionChip: 0,
				counter: 0,
				reportes: [],
				boleta: {
					dni: '',
					personal: '',
					mes: '',
					tipo_vendedor: ''
				},
				escolaridad: "",
				fiestas_patrias: "",
				navidad: "",
				montos_anteriores: [],
				totalRecords: 0,
				serverParams: {
					search: '',
					sort: {
						field: 'id',
						type: 'asc',
					},
					page: 1,
					perPage: 10
				},
				pagoResponsable:{
					dni:"",
					anio:"",
					mes:"",
					comision_numero_vendedores:"",
					vendedores_activos:"",
					suma_con_vendedores:"",
					comision_10p:"",
					total_cobrar:""
				},
				comisionPorNroVendedores:0,

			}
		},
		methods: {
			buscarPorResponsable() {
				let tipo=this.$store.state.usuario.tipo_vendedor;
				let departamento=this.$store.state.usuario.id_depa;
				this.reportes = [],
				this.proceso = true;
				axios.post(this.URL_BASE() + "personal/reporte_pago_responsable/" + this.anio + "/" + this.mes +'/'+tipo+'/'+departamento, ).then(respuesta => {
					//   console.log(respuesta.data.msg)
					if (respuesta.data.msg == 'exito') {
						this.reportes = respuesta.data.data
						this.comisionPorNroVendedores=respuesta.data.dataAdicional[0].pago;
						this.pagoResponsable.dni=this.$store.state.usuario.dni;
						this.pagoResponsable.anio=this.anio;
						this.pagoResponsable.mes=this.mes;
						this.pagoResponsable.comision_numero_vendedores=this.comisionPorNroVendedoresv2.toFixed(2);
						this.pagoResponsable.vendedores_activos=this.vendedoresActivos;
						this.pagoResponsable.suma_con_vendedores=this.sumaComisionVendedoresActivos.toFixed(2);
						this.pagoResponsable.comision_10p=this.comisionDiezPorciento.toFixed(2);
						this.pagoResponsable.total_cobrar=this.totalCobrar.toFixed(2);
						this.insertarComisionResponsable(this.pagoResponsable);
				
					}
					this.proceso = false;
				}).catch((error) =>{
					console.log("er store" + error);
				});
			},
			insertarComisionResponsable(pagoResponsable) {
			
				axios.post(this.URL_BASE() + "personal/insertar_pago_responsable" , pagoResponsable).then(respuesta => {
					//   console.log(respuesta.data.msg)
					
				}).catch( (error)=> {
					console.log("er store" + error);
				});
			},
			buscar() {
				this.reportes = [],
					this.proceso = true;
				axios.post(this.URL_BASE() + "personal/reporte_pago/" + this.anio + "/" + this.mes, ).then(respuesta => {
					//   console.log(respuesta.data.msg)
					if (respuesta.data.msg == 'exito') {
						this.reportes = respuesta.data.data

					}
					this.proceso = false;
				}).catch( (error) =>{
					console.log("er store" + error);
				});
			},
			cargarSaldoAnterior() {

				axios.post(this.URL_BASE() + "saldo_vendedor/saldo_anterior/" + this.boleta.dni + "/" + this.anio).then(
					respuesta => {
						if (respuesta.data.msg == 'exito') {

							this.montos_anteriores = respuesta.data.data;
						}

					}).catch( (error)=> {
					console.log("er store" + error);
				});
			},
			validarEscolaridad(mes) {
				return ['Enero', 'Febrero'].includes(mes);
			},
			validarFiestasPatrias(mes) {
				return ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio'].includes(mes);
			},
			validarFiestasNavidad(mes) {
				return ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Setiembre', 'Octubre',
					'Noviembre'
				].includes(mes);
			},
			imprimirBoleta(pagoChip, pagoEquipo, pagoAdelanto, pagoTotal, mes,nombrePersonal) {


				let nombreCompletoPersonal;
				if(this.$store.state.usuario.tipo==3 || this.$store.state.usuario.tipo==4 || this.$store.state.usuario.tipo==2 || this.$store.state.usuario.tipo==7|| this.$store.state.usuario.tipo==6){
					nombreCompletoPersonal=nombrePersonal;
				}else{
					nombreCompletoPersonal=this.$store.state.usuario.nombres + ' ' + this.$store.state
					.usuario.appa + ' ' + this.$store.state.usuario.apma ;
				}
				var mywindow = window.open('', 'Boleta', "scrollbars=yes, titlebar=yes");
				// var mywindow = window.open('', '_self').close();
				mywindow.document.write('<html><head>');
				mywindow.document.write(
					'<style>.tabla{width:100%;border-collapse:collapse;margin:16px 0 16px 0;}.tabla th{border:1px solid #ddd;padding:4px;background-color:#d4eefd;text-align:left;font-size:15px;}.tabla td{border:1px solid #ddd;text-align:left;padding:6px;}</style>'
					);
				mywindow.document.write('</head><body >');
				mywindow.document.write('<table class="tabla">');
				mywindow.document.write('<tr>');
				mywindow.document.write('<td style="width:50%">');
				mywindow.document.write('<img src="https://telemartin.com/app/assets/logo.png">');
				mywindow.document.write('</td>');
				mywindow.document.write('<td style="width:50%;text-align:right">');
				mywindow.document.write('<h1>TeleMartin</h1>');
				mywindow.document.write('<h3><i>Creciendo sin límites</i></h3>');
				mywindow.document.write('</td>');
				mywindow.document.write('</tr>');
				mywindow.document.write('<tr>');
				mywindow.document.write('<th colspan="2">');
				mywindow.document.write('PAGO DEL MES: ' + mes);
				mywindow.document.write('</th>');
				mywindow.document.write('</tr>');
				mywindow.document.write('<tr>');
				mywindow.document.write('<th colspan="2">');
				mywindow.document.write('PERSONAL: <b>' + nombreCompletoPersonal + '</b>');
				mywindow.document.write('</th>');
				mywindow.document.write('</tr>');
				mywindow.document.write('<tr>');
				mywindow.document.write('<td colspan="2">');
				mywindow.document.write('<B>A PAGAR:</B>');
				mywindow.document.write('</td>');
				mywindow.document.write('</tr>');
				mywindow.document.write('<tr>');
				mywindow.document.write('<td>');
				mywindow.document.write('--------PAGO ACTIVACIONES DE CHIPS');
				mywindow.document.write('</td>');
				mywindow.document.write('<td>');
				mywindow.document.write(pagoChip);
				mywindow.document.write('</td>');
				mywindow.document.write('</tr>');
				mywindow.document.write('<tr>');
				mywindow.document.write('<td>');
				mywindow.document.write('--------PAGO DE VENTA DE EQUIPOS');
				mywindow.document.write('</td>');
				mywindow.document.write('<td>');
				mywindow.document.write(pagoEquipo);
				mywindow.document.write('</td>');
				mywindow.document.write('</tr>');
				mywindow.document.write('<tr>');
				mywindow.document.write('<td>');
				mywindow.document.write('</td>');
				mywindow.document.write('<td>');
				mywindow.document.write('<B>' + (Number(pagoEquipo) + Number(pagoChip)).toFixed(2) + "</B>");
				mywindow.document.write('</td>');
				mywindow.document.write('</tr>');
				mywindow.document.write('<tr>');
				mywindow.document.write('<td colspan="2">');
				mywindow.document.write('<B>ADELANTOS:</B>');
				mywindow.document.write('</td>');
				mywindow.document.write('</tr>');
				mywindow.document.write('<tr>');
				mywindow.document.write('<td>');
				mywindow.document.write('--------MONTO DE ADELANTO');
				mywindow.document.write('</td>');
				mywindow.document.write('<td>');
				mywindow.document.write(pagoAdelanto);
				mywindow.document.write('</td>');
				mywindow.document.write('</tr>');
				mywindow.document.write('<tr>');
				mywindow.document.write('<th>');
				mywindow.document.write('TOTAL A PAGAR EN EL MES DE: ' + mes);
				mywindow.document.write('</th>');
				mywindow.document.write('<th>');
				mywindow.document.write("<h4>S/." + pagoTotal + "</h4>");
				mywindow.document.write('</th>');
				mywindow.document.write('</tr>');
				
				if (false) {
				// if (this.boleta.tipo_vendedor == 'PDV' && this.$store.state.usuario.tipo==2) {
					mywindow.document.write('<tr>');
					mywindow.document.write('<th colspan="2" style="text-align:center">');
					mywindow.document.write('--------------------------------');
					mywindow.document.write('</th>');
					mywindow.document.write('</tr>');
					mywindow.document.write('<tr>');
					mywindow.document.write('<th colspan="2">');
					mywindow.document.write('USTED VIENE ACUMULANDO:');
					mywindow.document.write('</th>');
					mywindow.document.write('</tr>');

					mywindow.document.write('<tr>');
					mywindow.document.write('<td>');
					mywindow.document.write('--------AGUINALDO POR ESCOLARIDAD:');
					mywindow.document.write('</td>');
					mywindow.document.write('<td>');
					mywindow.document.write('S/.' + this.escolaridad_total);
					mywindow.document.write('</td>');
					mywindow.document.write('</tr>');

					mywindow.document.write('<tr>');
					mywindow.document.write('<td>');
					mywindow.document.write('--------AGUINALDO POR FIESTAS PATRIAS:');
					mywindow.document.write('</td>');
					mywindow.document.write('<td>');
					mywindow.document.write('S/.' + this.fiestas_patrias_total);
					mywindow.document.write('</td>');
					mywindow.document.write('</tr>');

					mywindow.document.write('<tr>');
					mywindow.document.write('<td>');
					mywindow.document.write('--------AGUINALDO POR NAVIDAD:');
					mywindow.document.write('</td>');
					mywindow.document.write('<td>');
					mywindow.document.write('S/.' + this.navidad_total);
					mywindow.document.write('</td>');
					mywindow.document.write('</tr>');
				}

				// mywindow.document.write(document.getElementById('muestra').innerHTML);
				mywindow.document.write('</table>');
				mywindow.document.write('</body></html>');
				mywindow.document.close(); // necesario para IE >= 10
				mywindow.focus(); // necesario para IE >= 10
				mywindow.print();
				// mywindow.close();
				return true;
			},
			filtrar(tipo){
			  let nuevoTipo=this.$store.state.dataTipoVendedor.filter(elemento=>elemento.Id==tipo);

			  return nuevoTipo[0].tipo;
			},

		},
		computed: {

			comisionPorNroVendedoresv2(){
				
				let total=0;
				if(this.$store.state.usuario.tipo=='3'){
					total=this.vendedoresActivos*40;
				}
				if(this.$store.state.usuario.tipo=='4'){
					total=this.vendedoresActivos*10;
				}

				if(this.$store.state.usuario.tipo=='7'||this.$store.state.usuario.tipo=='6'||this.$store.state.usuario.tipo=='5'){
					total=this.vendedoresActivos*10;
				}

				return total;
			},
			totalCobrar() {
				let total=parseFloat(this.comisionDiezPorciento)+parseFloat(this.comisionPorNroVendedoresv2);
				
				
				return total;
			},
			vendedoresActivos() {
				let contador=0;
				if(this.$store.state.usuario.tipo=='3'){
					this.reportes.forEach(element => {
							let total=parseFloat(element.total)+parseFloat(element.monto_adelanto);
					if(total>=200){
						contador++;
					}
				});
				}
				if(this.$store.state.usuario.tipo=='4'){
					this.reportes.forEach(element => {
						let total=parseFloat(element.total)+parseFloat(element.monto_adelanto);
						
					if(total>=10){
						contador++;
					}
				});
				}
				if(this.$store.state.usuario.tipo=='7'||this.$store.state.usuario.tipo=='6'||this.$store.state.usuario.tipo=='5'){
					this.reportes.forEach(element => {
						let total=parseFloat(element.total)+parseFloat(element.monto_adelanto);
						
					if(total>=20){
						contador++;
					}
				});
				}


				
		return contador;
			},
			sumaComisionVendedoresActivos() {
				let contador=0;
				if(this.$store.state.usuario.tipo=='3'){
					this.reportes.forEach(element => {
					let total=parseFloat(element.total)+parseFloat(element.monto_adelanto);
					if(total>=200){
						contador=contador+total;
					}
				});
				}
				if(this.$store.state.usuario.tipo=='4'){
					this.reportes.forEach(element => {
						let total=parseFloat(element.total)+parseFloat(element.monto_adelanto);
					if(total>=10){
						contador=contador+total;
					}
				});
				}
				if(this.$store.state.usuario.tipo=='7' || this.$store.state.usuario.tipo=='6' || this.$store.state.usuario.tipo=='5'){
					this.reportes.forEach(element => {
						let total=parseFloat(element.total)+parseFloat(element.monto_adelanto);
					if(total>=20){
						contador=contador+total;
					}
				});
				}


				
		return contador;
			},
			comisionDiezPorciento() {
				let total=this.sumaComisionVendedoresActivos;
				return total*0.10;

			},
			total() {
				return this.reportes.reduce((total, item) => {
					return total + Number(item.total);
				}, 0.00);
			},
			total_chip() {
				return this.reportes.reduce((total, item) => {
					return total + Number(item.monto_chip);
				}, 0.00);
			},
			total_equipo() {
				return this.reportes.reduce((total, item) => {
					return total + Number(item.monto_equipo);
				}, 0.00);
			},
			total_adelanto() {
				return this.reportes.reduce((total, item) => {
					return total + Number(item.monto_adelanto);
				}, 0.00);
			},
			escolaridad_total() {
				let total = 0;
				this.montos_anteriores.forEach(element => {
					if (this.validarEscolaridad(element.mes)) {
						total = total + (element.monto_chip * 0.15);
					}
				});
				return total.toFixed(2);
			},
			fiestas_patrias_total() {
				let total = 0;
				this.montos_anteriores.forEach(element => {
					if (this.validarFiestasPatrias(element.mes)) {
						total = total + (element.monto_chip * 0.10);
					}
				});
				return total.toFixed(2);
			},
			navidad_total() {
				let total = 0;
				this.montos_anteriores.forEach(element => {
					if (this.validarFiestasNavidad(element.mes)) {
						// total=total+(Number(element.total)*0.10).toFixed(2);
						total = total + (element.monto_chip * 0.10);
					}
				});
				return total.toFixed(2);
			}
		},
	}
</script>